import React from 'react'
import { cn } from '@/utilities/ui'
import { getBlockPadding, type BlockPaddingOptions } from '@/utilities/getBlockPadding'

interface BlockContainerProps extends BlockPaddingOptions {
  children: React.ReactNode
  disableInnerContainer?: boolean
  className?: string
}

export const BlockContainer: React.FC<
  BlockContainerProps & React.ComponentPropsWithoutRef<'div'>
> = ({
  children,
  disableInnerContainer,
  className,
  paddingTop = true,
  paddingBottom = true,
  ...rest
}) => {
  return (
    <div
      className={cn(
        getBlockPadding({ paddingTop, paddingBottom }),
        {
          container: !disableInnerContainer,
        },
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
}
